import { observer } from "mobx-react"
import React, { useMemo } from "react"

import Button from "~/components/atoms/Button"
import Typography from "~/components/atoms/Typography"
import ProgressCircle from "~/components/molecules/ProgressCircle"
import { Color } from "~/consts/style-mixins"
import { useMobileMedia } from "~/hooks/useMobileMedia"
import { internalLink } from "~/services/helper"
import { useStores } from "~/stores/StoreProvider"

import { Inline } from "../AuthRegisterPage/components/Inline"
import * as Styled from "./styled"

export const AuthRegisterCompleteJobHunting: React.FC = observer(() => {
  const { userStore, inputProfileFlowStore } = useStores()
  const isMobile = useMobileMedia()

  const enteredRate = useMemo(() => {
    if (inputProfileFlowStore.enteredRate === undefined || inputProfileFlowStore.enteredRate === 100) {
      return
    }
    return inputProfileFlowStore.enteredRate
  }, [inputProfileFlowStore.judgeEntered])

  return (
    <Styled.AuthRegisterCompleteJobHuntingContainer>
      <div className="container">
        <div className="balloon-container">
          <div className="balloon">さらに</div>
        </div>
        <div className="catch-copy-container">
          <Typography type={isMobile ? "SubHeading" : "Heading"}>
            プロフィールを充実させ<Styled.ForPc>、</Styled.ForPc>
            <Inline color={Color.Attention}>
              <Typography type={isMobile ? "Heading" : "Hero"} colorProp="inherit" inline>
                新卒スカウト
              </Typography>
              をつかもう<Styled.ForPc>！</Styled.ForPc>
            </Inline>
          </Typography>
        </div>

        {enteredRate && (
          <div className="progress-container">
            <div className="progress-circle">
              <ProgressCircle percentage={enteredRate} labelSize={isMobile ? 28 : 37} unitSize={12} />
            </div>
            <div className="progress-message">
              <Typography
                type={isMobile ? "SubLabel" : "Label"}
                colorProp={Color.Black}
                lineHeightProp={isMobile ? undefined : 160}
              >
                {userStore.user && `${userStore.user.name}さんの`}
                <Inline color={Color.Attention}>主要項目の進捗率は{enteredRate}％</Inline>です。
                <br />
                まずは<Inline color={Color.Primary}>選考で重要視される項目を入力</Inline>してアピールしよう！
              </Typography>
            </div>
          </div>
        )}
        <div className="button-text-container">
          <Typography type="SubLabel" colorProp={Color.Black}>
            ＼ここさえ押さえれば完璧！最重要項目をピックアップ／
          </Typography>
        </div>
        <div className="button-container">
          <a
            href={internalLink("/input-profile-flow?access_from=registration-complete")}
            className="gtm_profile-button-after-register"
          >
            <Button size={isMobile ? "Small" : "Medium"} onClick={() => {}} type="submit">
              未入力項目を入力する
            </Button>
          </a>
        </div>
      </div>
    </Styled.AuthRegisterCompleteJobHuntingContainer>
  )
})
